import { ResourceAutoCompleteViewModelType } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { ViewModelTypeAutocomplete } from '../../../../containers/Settings/PhoneNumbers/components/ViewModelTypeAutocomplete';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (item: string) => void;
	className?: string;
}

export const TeamSelect: React.FC<IProps> = ({ onChange, className }) => {
	const [selectedItem, selectItem] = useState(null);
	const handleSelection = (value: string) => {
		onChange(value);

		selectItem(value);
	};
	return (
		<ViewModelTypeAutocomplete<string>
			className={className || css(styleSheet.autocomplete)}
			placeholder={selectedItem ? 'Team: ' + selectedItem : 'Filter by Team'}
			model={ResourceAutoCompleteViewModelType.Team}
			onChange={handleSelection}
		/>
	);
};
